const es = {
  notFound: 'Proveedor no fue encontrado',
  notFoundctx:
    'Por favor, acceda al portal con en enlace enviado via email. Si sigues viendo esta mensaje, por favor entra en contacto con nosotros via',
  customer_portal_tag_line: `Recopile y procese sus documentos automáticamente garantizando una ejecución sin errores`,
  customerDeleted: 'Proveedor borrado. Compruebe tu enlace o tus autorizaciones',
  step1: 'Paso 1. Selecciona',
  step1ctx: 'Selecciona facturas de tus archivos.',
  step2: 'Paso 2. Revisa',
  step2ctx: 'Revisa si las facturas correctas fueron seleccionadas.',
  step3: 'Paso 3. Carga',
  step3ctx: 'Carga las facturas.',
  login: 'Inicia Sesión',
  drop: 'Arrastra o selecciona documentos.',
  dropctx1: 'Arrastra archivos o pulsa',
  dropctx2: 'explorar',
  dropctx3: 'para seleccionar',
  selected: 'Documentos seleccionados:',
  removeAll: 'Eliminar Todo',
  upload: 'Cargar documentos',
  useDedicatedLink:
    'No puedes cargar sin usar tu enlace dedicado. Por favor, utilice el enlace que le hemos enviado por correo eletronico.',
  duplicateNotAllowed: 'Archivos duplicados no permitidos',
  limit: 'Límite de 10 archivos.',
  successUpload: 'Documento(s) cargado(s) exitosamente',
  errorUpload: 'Error cargandos archivos: ',
  logout: 'Cerrar sesión',
  email: {
    enterEmail: 'Introduzca tu email para recibir un código de confirmación',
    enterEmailCtx: 'Eso ayuda a asegurarnos de que eres tú antes de permitir cargas',
    sendCode: 'Enviar código',
    checkEmail: 'Solicitud enviada con éxito!',
    checkEmailCtx1: 'Hemos enviado un código de 6 dígitos para ',
    checkEmailCtx2:
      '. Por favor, introduzca el código en el hueco de abajo para verificar tu email.',
    confirm: 'Confirmar',
    code: 'Código',
    resend: 'No has recibido?',
    resendLink: 'Volver a enviar',
    codeResent: 'Código fue enviado otra vez a tu email',
    wrongCode: 'Código incorrecto',
  },
  loadingCustomer: 'Cargando proveedor...',
  NeedReview: 'Necesita revisión',
  Duplicate: 'Duplicado',
  Default: 'En progreso',
  Extracted: 'Extraído',
  Failed: 'Fallido',
  Error: 'Error',
  Reviewed: 'Revisado',
  'Add Document': 'Añadir Documento',
  'Created on': 'Creado en',
  Status: 'Estado',
  Date: 'Fecha',
  Message: 'Mensaje',
  Close: 'Cerca',

  'Document name': 'Nombre del documento',
  Paid: 'Pagado',
  UnPaid: 'No pagado',
  Approved: 'Aprobado',
  Rejected: 'Rechazado',
  'Payment status': 'Estado de pago',
  'ERP status': 'Estado ERP',
  All: 'Todos',
  Documents: 'Documentos',
  'Erp status': 'Estado ERP',
  Actions: 'Acciones',
  'Created in ERP': 'Creado en ERP',
  Yes: 'Si',
  No: 'No',
  Pending: 'Pendiente',
  'View ERP details': 'Ver detalles ERP',
  'ERP Details': `Detailles ERP`,
  'View payment details': 'Ver detalles de pago',
  'Payment Details': 'Detalles del pago',
  'Payment Date': 'Fecha de pago',
  'Transaction method': 'Método de transacción',
  'Rows per page': 'Filas por página',
  of: 'de',
  a_maximum_of_10_files_are_allowed_in_a_single_upload: `Se permite un máximo de 10 archivos en una sola carga`,
  upload_by_device: 'Subir por dispositivo',
  select_language: 'Seleccionar idioma',
  no_data: `Sin Datos`,
  add_a_new_document: `Agregar un nuevo documento`,
  entries_per_page: `Entradas por página`,
  'Drop your files here or browse through your machine.': `Suelte sus archivos aquí o navegue por su máquina.`,
  browse: `Navegar`,
  upload_documents: `Subir documentos`,
  upload_from_device: `Subir desde el dispositivo`,
  // Create Document
  create_document: `Crear documento`,
  document_information: `Información del documento`,
  account_class: `Clase de cuenta`,
  account_payable: `Cuenta por pagar`,
  document_class: `Clase de documento`,
  deliveryNote: `Albarán de entrega`,
  invoice: `Factura`,
  documentNumber: `Número de documento`,
  documentDate: `Fecha del documento`,
  add_valid_date: `Agregar fecha válida`,
  documentClass_is_required: `Se requiere clase de documento`,
  documentNumber_is_required: `El número de documento es obligatorio`,
  poNumber_is_required: `Se requiere el número de orden de compra`,
  totalAmount: `Monto total`,
  taxPercentage: `Porcentaje de impuesto`,
  customer_information: `Información al cliente`,
  supplier_information: `Información del proveedor`,
  customerCompanyName: `Nombre de la empresa del`,
  customerCompanyID: `ID de la empresa del`,
  customerCompanyAddress: `Dirección de la empresa del`,
  customerEmail: `Correo electrónico del`,
  customerCompanyName_is_required: `El nombre de la empresa del es obligatorio`,
  customerCompanyID_is_required: `Se requiere el ID de la empresa del`,
  customerCompanyAddress_is_required: `Se requiere la dirección de la empresa del`,
  customerEmail_is_required: `El correo electrónico del es obligatorio`,
  document_is_required: `El documento es requerido`,
  account_information: `Información de la cuenta`,
  vendor_information: `Informacion del proveedor`,
  items_information: `Información de los artículos`,
  taxes_information: `Información de impuestos`,
  optional: `Opcional`,
  account_receivable: `cuenta por cobrar`,
  accountClass_is_required: `Se requiere clase de cuenta`,
  back: `Atrás`,
  next: `Próximo`,
  invoiceID: `ID de factura`,
  poNumber: `Numero postal`,
  totalWithoutTax: `Total (sin impuestos)`,
  totalTax: `Total impuestos`,
  invoiceDate: `Fecha de la factura`,
  dueDate: `Fecha de vencimiento`,
  invoiceId_is_required: `Se requiere identificación de factura`,
  totalWithoutTax_is_required: `Se requiere total sin impuestos`,
  totalTax_is_required: `Se requiere el impuesto total`,
  totalAmount_is_required: `Se requiere cantidad total`,
  taxPercentage_is_required: `Se requiere porcentaje de impuesto`,
  deliveryNote_is_required: `Se requiere albarán de entrega`,
  invoiceDate_is_required: `Se requiere fecha de factura`,
  documentDate_is_required: `Se requiere fecha del documento`,
  dueDate_is_required: `Se requiere fecha de vencimiento`,
  vendorCompanyName: `Nombre de la empresa proveedora`,
  vendorCompanyID: `ID de la empresa proveedora`,
  vendorCompanyAddress: `Dirección de la empresa proveedora`,
  vendorCompanyName_is_required: `Se requiere el nombre de la empresa proveedora`,
  vendorCompanyID_is_required: `Se requiere el ID de la empresa proveedora`,
  vendorCompanyAddress_is_required: `Se requiere la dirección de la empresa proveedora`,
  referenceCode: `Código de referencia`,
  unit: `Unidad`,
  unitPrice: `Precio unitario`,
  vatPercentage: `IVA %`,
  vat: `IVA`,
  dtoPercentage: `DTO %`,
  dto: `DTO`,
  discountPercentage: `% de descuento`,
  discount: `Descuento`,
  subTotalAmount: `Monto subtotal`,
  referenceCode_is_required: `Se requiere código de referencia`,
  description_is_required: `Se requiere descripción`,
  unit_is_required: `Se requiere unidad`,
  unitPrice_is_required: `Se requiere precio unitario`,
  quantity_is_required: `Se requiere cantidad`,
  vatPercentage_is_required: `Se requiere porcentaje de IVA`,
  vat_is_required: `Se requiere IVA`,
  dtoPercentage_is_required: `Se requiere porcentaje de DTO`,
  dto_is_required: `Se requiere DTO`,
  discountPercentage_is_required: `Se requiere porcentaje de descuento`,
  discount_is_required: `Se requiere descuento`,
  subTotalAmount_is_required: `Se requiere el monto subtotal`,
  amount_is_required: `Se requiere cantidad`,
  delete_item: `Eliminar elemento`,
  update_item: `Actualizar elemento`,
  delete_items: `Eliminar objetos`,
  taxes: `Impuestos`,
  baseAmount: `Cantidad base`,
  add_tax: `Agregar impuesto`,
  submit: `Someter`,
  reset: `Reiniciar`,
  atleast_one_item_is_required: `Se requiere al menos un artículo`,
  atleast_one_tax_is_required: `Se requiere al menos un impuesto`,
  submit_and_create_new_document: `Enviar y crear un nuevo documento`,
  baseAmount_is_required: `Se requiere cantidad base`,
  vendorEmailAddress: `Dirección de correo electrónico del proveedor`,
  add_item: `Añadir artículo`,
  vendorEmail_is_required: `Se requiere la dirección de correo electrónico del proveedor`,
  email_invalid: `El correo electrónico debe ser una dirección de correo electrónico válida`,
  quantity: `Cantidad`,
  amount: `Cantidad`,
  actions: `Acciones`,
  Edit: `Editar`,
  Cancel: `Cancelar`,
  description: `Descripción`,
  delete_approval: `Estás seguro de que quieres eliminar esto`,
  cancel_button: `Cancelar`,
  delete: `Eliminar`,
  delete_tax: `Eliminar impuesto`,
  delete_taxes: `Eliminar impuestos`,
  only_one_document_is_allowed_to_upload: `Sólo se permite cargar un documento`,
  upload_document: `Subir documento`,
  tax: `Impuesto`,
  document_created_successfully: `Documento creado exitosamente`,
  update_tax: `Actualizar impuesto`,
  my_information: `Mi informacion`,
  emailAddress: `Dirección de correo electrónico`,
  companyAddress: `Dirección de empresa`,
  companyID: `ID de empresa`,
  companyName: `El nombre de empresa`,
  companyName_is_required: `El nombre de la empresa es obligatorio`,
  companyID_is_required: `Se requiere el ID de la empresa`,
  companyAddress_is_required: `La dirección de la empresa es obligatoria`,
  email_is_required: `Se requiere dirección de correo electrónico`,
  dueDate_should_be_greater_than_documentDate: `La fecha de vencimiento debe ser mayor que la fecha del documento`,
  documentDate_should_be_less_than_dueDate: `La fecha del documento debe ser menor que la fecha de vencimiento`,
  'tax_amount_not_%': 'Impuesto (monto)',
  document_details: `Detalles del documento`,
  date_details: `Detalles de la fecha`,
  logo_url: `URL del logotipo`,
  please_enter_your_information: `Por favor ingresa tu información`,
  please_enter_supplier_information: `Detalles del proveedor a quién se enviará este documento`,
  'Approval Process': `Proceso de aprobación`,
  tax_must_be_number: `Se requiere el impuesto y debe ser numérico`,
  discount_must_be_number: `El descuento debe ser un número`,
  unitPrice_must_be_number: `El precio unitario es obligatorio y debe ser un número`,
  quantity_must_be_number: `La cantidad es obligatoria y debe ser un número`,
  baseAmount_must_be_number: `Se requiere un monto base y debe ser un número`,
  tax_is_required: `Se requiere impuesto`,
  customer: `Cliente`,
  'My profile': `Mi perfil`,
  Logout: `Cerrar sesión`,
  'Email must be a valid email address': `El correo electrónico debe ser una dirección de correo electrónico válida`,
  'Email is required': `El correo electrónico es obligatorio`,
  'Name is required': `El nombre es obligatorio`,
  registration_number_required: `Se requiere el número de registro`,
  registration_number_validation2: `El número de registro debe ser un número`,
  registration_number_validation1: `El número de registro no puede tener más de 20 caracteres`,
  iban_validation_2: `El IBAN debe ser alfanumérico`,
  iban_validation_1: `El IBAN no puede tener más de 24 caracteres`,
  'My Profile': `Mi perfil`,
  name: `Nombre`,
  Email: `Correo electrónico`,
  registration_number: `Número de registro`,
  account_holder_name: `Nombre del titular de la cuenta`,
  iban: `IBAN`,
  'Go back': `Regresar`,
  Save: `Guardar`,
  Invoice: `Factura`,
  PurchaseOrder: `Orden de compra`,
  DeliveryNote: `Albarán de entrega`,
  tax_type: `Tipo de impuesto`,
  tax_type_is_required: `Se requiere el tipo de impuesto`,
  total_discount: `Descuento total`,
  finance_screen: {
    email_text: `Tu email dedicado al envio de documentos`,
    docs_processed: `Documentos Procesados`,
    email_csv_export: `Exportar CSV en email`,
    selected_files: `Archivo(s) Seleccionados`,
    remove_all: `Eliminar todo`,
    upload_files: `Cargar Archivos`,
    duplicate_files_are_not_allowed: `No se permiten archivos duplicados`,
    files_cannot_be_more_than_10: `Los archivos no pueden ser más de 10`,
    document_uploaded_successfully: `Documento subido correctamente`,
    extract_now: `Extraer ahora`,
    all: `Todo`,
    Invoice: `Facturas`,
    PurchaseOrder: `Ordenes de compra`,
    credit_memo: `Abono`,
    DeliveryNote: `Albaranes`,
    Reciepts: `Recibos`,
    filename: `Nombre del archivo`,
    processed_at: `Procesado el`,
    output: `Salida`,
    status: `Estado`,
    creeated_in_erp: `Creado en el ERP`,
    no_data: `Sin Datos`,
    dense: `Justificado`,
    rows_per_page: `Líneas por página:`,
    retry_button: `Reintentar`,
    yes_button: `Sí`,
    no_button: `No`,
    start_date: `Fecha de inicio`,
    end_date: `Fecha final`,
    search: `Buscar`,
    document_upload_unsuccessful: `Error al cargar el documento`,
    'Document not supported': `Documento no compatible`,
    'Number of pages exceed': `Número de páginas excedido`,
    'Limit Exceed': `Límite de documentos excedido`,
    document_name: `Nombre del documento`,
    SimpleNote: `Nota Simple`,
    WorkContract: `Contrato de trabajo`,
    Payroll: `Nómina`,
    DNI: `DNI`,
    Passport: `Pasaporte`,
    NIE: `NIE`,
    SimulatedInvoice: `Factura Simulada`,
    output_data: `Datos de salida`,
    CreditNote: `Nota de crédito`,
    failed_to_fetch_document_version_id: `No se pudo obtener el ID de la versión del documento`,
  },
  status: {
    in_process: `En proceso`,
    processed: `Procesado`,
    failed: `Error`,
    error: `Error`,
    need_review: `Revisar`,
    reviewed: `Revisado`,
    duplicate: `Duplicado`,
    connected: `Conectado`,
    not_connected: `No Conectado`,
    success: `Éxito`,
    plan: `libre`,
  },
  Filters: `Filtros`,
  'Document status': `Estado del documento`,
  'Approval status': `Estado de aprobación`,
  'ERP integrated': `ERP integrado`,
  'Include deleted documents': `Incluir documentos eliminados`,
  'Clear all': `Limpiar todo`,
  'Search ...': `Buscar ...`,
  'Create Purchase order': `Crear orden de compra`,
  'Upload Purchase Order': `Cargar orden de compra`,
  'Upload purchase order': `Cargar orden de compra`,
  'Delete document': `Eliminar documento`,
  'Are you sure you want to delete this document?': `¿Estás seguro de que quieres eliminar este documento?`,
  'Are you sure you want to delete all documents?': `¿Estás seguro de que quieres eliminar todos los documentos?`,
  'Are you sure you want to delete these documents?': `¿Estás seguro de que quieres eliminar estos documentos?`,
  deleted_document: `Documento eliminado`,
  NeedApproval: 'Necesita Aprobación',
  Onboarding: `En proceso`,
  'Complete Your Profile': `Completa tu perfil`,
  "You're almost done! Complete any missing information to finish your setup.": `¡Casi terminas! Completa cualquier información faltante para finalizar tu configuración.`,
  'Bank Details': `Detalles bancarios`,
  'Verify Your Bank Details': `Verifica tus detalles bancarios`,
  'Review your bank information and fill in any gaps for smooth transactions.': `Revise su información bancaria y complete cualquier vacío para transacciones sin problemas.`,
  Profile: `Perfil`,
  'Supplier Updated': `Proveedor actualizado`,
  deleted_documents: `Documentos eliminados`,
  something_went_wrong: `Algo salió mal`,
  'Company ID': `ID de la empresa`,
  'Onboarding completed': `Registro completado`,
  Finish: `Terminar`,
  Continue: `Continuar`,
  Back: `Atrás`,
  'Nationality is required': 'Se requiere la nacionalidad',
  'Tax Identification Number is required': 'Se requiere el Número de Identificación Fiscal',
  'Registered address is required': 'Se requiere la dirección registrada',
  account_holder_name_required: `Se requiere el nombre del titular de la cuenta`,
  'IBAN cannot be more than 24 characters': `El IBAN no puede tener más de 24 caracteres`,
  'IBAN is required': `El IBAN es obligatorio`,
  'IBAN is not valid': `El IBAN no es válido`,
  action: 'Acciones',
  'View document': 'Ver documento',
  not_document_owner: 'No puede eliminar este documento',

  // Payment Gateway
  payments: 'Pagos',
  payment_gateways: `Pasarelas de pago`,
  payment_gateway_not_connected: `Pasarela de pago no conectada`,
  add_payment_gateway: `Agregar pasarela de pago`,
  connect: `Conectar`,
  disconnect: `Desconectar`,
  in_process: `En proceso`,
  new_payment_gateway_button_text: `Conectar nueva pasarela de pago`,
  payment_gateway_disconnected_successfully: '{{paymentGatewayName}} se desconectó con éxito',
  payment_gateway_connection_request_sent: '{{paymentGateway}} solicitud de conexión enviada',
  disconnect_payment_gateway: 'Desconectar {{paymentGateway}}',
  disconnect_payment_gateway_warning:
    '¿Estás seguro de que quieres desconectar {{paymentGateway}}? Una vez desconectado, se perderán todas las configuraciones.',
  paymentgateway_notallowed_toconnect_multiplegateways:
    'No se permite conectar múltiples pasarelas de pago',

  paymentgateway_not_found: 'Pasarela de pago no encontrada',
  make_payment: `Realizar pago`,
  'payment_all_selected_document(s)_workflow_shouldbe_approved':
    'El pago de todos los documentos seleccionados debe ser aprobado en el flujo de trabajo.',
  payment_supplier_vendorid_not_found: `ID de proveedor no encontrado`,
  payment_method: `Método de pago`,
  payment_details: `Detalles de pago`,
  sub_total: `Total parcial`,
  process_payment: `Procesar pago`,
  'Bank To Bank': `Banco a Banco`,
  balance: `Saldo`,
  From: `De`,
  To: `A`,
  vendorCompanyId: `ID de la empresa proveedora`,
  'fee_0%': `Tarifa 0%`,
  total: `Total`,
  payment_made_successfully: `Pago realizado con éxito`,
  transaction_id: `ID de transacción`,
  created_by: `Creado por`,
  created_on: `Creado el`,
  invoice_payments: `Pagos de factura`,
  transacted_by: `Transacción por`,
  transacted_on: `Transacción el`,
  details: `Detalles`,
  company_id: `ID de la empresa`,
  no_payments_found: `No se encontraron pagos`,
  'payment_all_selected_document(s)_shouldbe_processed_or_reviewed':
    'Todos los documentos seleccionados deben procesarse o revisarse',
  Success: `Éxito`,
  'Customer Updated': `Cliente actualizado`,
  denied_payment: `Pago denegado`,
  payment_account_class_should_be_account_receivable: `La clase de cuenta debe ser cuenta por cobrar`,
  payment_supplier_iban_not_found: `IBAN del proveedor no encontrado`,
  payment_supplier_account_info_not_found: `No se encontró la información de la cuenta del proveedor`,
  payement_customer_notfound: `Cliente no encontrado`,
  payement_customer_deleted: `Cliente eliminado`,
  payement_customer_incomplete_onboarding: `Incorporación de cliente incompleta`,
  payment_gateway_account_not_activated: `Cuenta de pasarela de pago no activada`,
  payment_select_not_deleted_document: `No se puede realizar el pago del documento eliminado`,
  payment_account_class_should_be_receiveable: `La clase de cuenta debe ser por cobrar`,
  'payment_all_selected_document(s)_type_shouldbe_invoice': `Todos los tipos de documentos seleccionados deben ser facturas`,
  payment_invoice_amout_greaterthan_zero: `El importe del pago debe ser mayor que cero`,
  Process: `Proceso`,
  PartialPaid: `Pago parcial`,
  payment_you_have_insufficient_balance_to_complete_transaction: `Tienes saldo insuficiente para completar la transacción`,
  source: `Fuente`,
  method: `Método`,
  processed_by_and_date: `Procesado por y fecha`,
  BankTransfer: `Transferencia bancaria`,
  coming_soon: `Próximamente`,
  vendor_currency_notmatch_payeeaccount_currency: `La moneda del proveedor no coincide con la moneda del beneficiario`,
  tax_info_not_required: `La información fiscal no es necesaria ya que está incluida en la información de los artículos. Sin embargo, puede especificar la retención en la fuente (WHT) si corresponde.`,
  // Permissions
  access_forbidden: `Acceso prohibido`,
  you_dont_have_permission_to_access_this_page: `No tienes permiso para acceder a esta página`,
  go_to_homepage: `Ir a la página de inicio`,
  unexpected_error: `Ha ocurrido un error`,
  companyID_cannot_contain_comma: `El ID de la empresa no puede contener comas`,
  Currency: `Moneda`,
  currency_is_required: `Se requiere moneda`,
  no_: 'No.',
  document_date: 'Fecha del documento',
  vendor_address: 'Dirección del proveedor',
  vendor_id: 'ID del proveedor:',
  code: 'Código',
  purchase_order: 'Orden de compra',
  delivery_note: 'Nota de entrega',
  unit_price: 'Precio unitario',
  subtotal: 'Subtotal',
  total_without_tax: 'Total (sin impuestos)',
  total_tax: 'Total de impuestos',
  of_: 'de',
  'Create Delivery Note': 'Crear nota de entrega',
  'Create Invoice': 'Crear factura',
  'Create Purchase Order': 'Crear orden de compra',
  'Catalog item': 'Elemento del catálogo',
  WHT: 'Retención de impuestos',
  VAT: 'IVA',
  address: `Dirección`,
  notes: `Notas`,
  note: `Nota`,
  view_notes: `Ver notas`,
  add: `Agregar`,
  close: `Cerrar`,
  no_data_found: `No se encontraron datos`,
  resource_not_found: `Recurso no encontrado`,
  add_filter: `Agregar filtro`,
  document_filters: `Filtros de documento`,
  field_name: `Nombre del campo`,
  field_value: `Valor del campo`,
  field_value_is_required: `El valor del campo es obligatorio`,
  field_name_is_required: `El nombre del campo es obligatorio`,
  view_details: `Ver detalles`,
  delete_note_title: `Eliminar nota`,
  add_a_note: `Agregar una nota`,
  no_notes_found: `No se encontraron notas`,
  note_is_required: `La nota es obligatoria`,
  note_validation_max_length: `La nota no puede tener más de 1000 caracteres`,
  notes_length_exceed: `Se ha excedido la longitud de las notas`,
  note_deletedBy_deletedOn: `Eliminado por {{deletedBy}} el {{deletedOn}}`,
  document_note_not_owner: `No eres el propietario de esta nota y no puedes realizar esta acción.`,
  error_parsing_customer_info: `Error al analizar la información del cliente`,
  // Legal Representative
  legal_representative_details: `Detalles del representante legal`,
  verify_your_legal_representative_details: `Verifica los detalles de tu representante legal`,
  first_name: `Nombre`,
  last_name: `Apellido`,
  document_type: `Tipo de documento`,
  document_code: `Código de documento`,
  street: `Calle`,
  street_number: `Numero de calle`,
  number: `Número`,
  municipality: `Municipio`,
  province: `Provincia`,
  zipCode: `Código postal`,
  country: `País`,
  legal_representative_information: `Información del representante legal`,
  general_information: `Información general`,
  dni_number: 'Número de DNI',
  id_card_front_document: 'DNI (Anverso)',
  id_card_back_document: 'DNI (Reverso)',
  upload_front_id_card: 'Subir anverso del DNI',
  upload_back_id_card: 'Subir reverso del DNI',
  discounts_information: `Información de descuentos`,
  total_after_discount: `Total después del descuento`,
  total_before_discount: `Total antes del descuento`,
  'attach_support_document_(optional)': `Adjuntar documento de soporte (opcional)`,
  companyid_must_be_unique: `El ID de la empresa debe ser único`,
  firma: `Firma`,
  subir_firma: `Subir firma`,
  remove: `Eliminar`,
  comments: `Comentarios`,
  field_name_cannot_exceed_characters: `{{fieldName}} no puede exceder los {{number}} caracteres.`,
  failed_to_fetch_notifications: 'No se pudieron obtener las notificaciones',
  new_app_verion_available:
    'Por favor, actualiza la página para obtener la última versión de Dost.',
  update_available: 'Nosotras hemos hecho algunas mejoras',
  refresh: 'refrescar',
  phone_number: `Número de teléfono`,
  locality: `Localidad`,
  region: `Región`,
  customer_address_info: `Información de dirección del cliente`,
  basic_information: `Básica información`,
  powered_sage: 'Powered by CONTROL AI SOLUTIONS',
  // duplicate-document-number dialog (existing)
  document_number_already_exists: `El número de documento ya existe`,
  document_number_exists_message: `Ya se ha asignado este número de documento: {{documentNumber}}`,
  would_you_like_to_generate_new_document_number: `¿Le gustaría generar un nuevo número de documento?`,
  regenerate_document_number: `Regenerar número de documento`,
  document_number_regenerated_successfully: `Número de documento regenerado correctamente`,

  // section headings
  verifactu_simplified_invoice: `Factura simplificada de Verifactu`,
  sii_simplified_invoice: `Factura simplificada SII`,
  verifactu_regular_invoice: `Factura regular Verifactu`,
  sii_regular_invoice: `Factura regular SII`,
  verifactu_debit_note: `Nota de débito Verifactu`,
  sii_credit_note: `Nota de crédito SII`,
  verifactu_credit_note: `Nota de crédito Verifactu`,
  sii_corrective_invoice: `Factura rectificativa SII`,
  verifactu_corrective_invoice: `Factura rectificativa Verifactu`,
  sdi_regular_invoice: `Factura regular SDI`,
  corrective_invoice: `Factura rectificativa`,
  replacement_invoice: `Factura sustitutiva`,
  sdi_credit_note: `Nota de crédito SDI`,
  recurring_invoice: `Factura recurrente`,
  recurring_invoice_information: `Información de factura recurrente`,

  // document info fields
  ExpenseCategory: `Categoría de gasto`,
  rectificationReason: `Motivo de la rectificación`,
  SpainCorrectionCode: `Código de rectificación`,

  // company / contact
  companyEmail: `Correo electrónico de la empresa`,
  email_address: `Dirección de email`,

  // customer address breakdown
  CustomerCompanyStreet: `Calle de la empresa`,
  CustomerCompanyStreetNumber: `Número de calle de la empresa`,
  CustomerCompanyLocality: `Localidad de la empresa`,
  CustomerCompanyRegion: `Región de la empresa`,
  CustomerCompanyZipCode: `Código postal de la empresa`,
  CustomerCountry: `País del`,
  customerCompanyStreet_is_missing: `Falta la calle de la empresa`,
  customerCompanyStreetNumber_is_missing: `Falta el número de calle de la empresa`,
  customerCompanyLocality_is_missing: `Falta la localidad de la empresa`,
  customerCompanyRegion_is_missing: `Falta la región de la empresa`,
  customerCompanyZipCode_is_missing: `Falta el código postal de la empresa`,

  // vendor address breakdown
  VendorCompanyStreet: `Calle de la empresa`,
  VendorCompanyStreetNumber: `Número de calle de la empresa`,
  VendorCompanyLocality: `Localidad de la empresa`,
  VendorCompanyRegion: `Región de la empresa`,
  VendorCompanyZipCode: `Código postal de la empresa`,
  VendorCountry: `País del`,

  // buttons / status
  configuration: `Configuración`,

  // stacked layout (new UI)
  create_compliance_standard_document: `Crear {{complianceStandard}} {{documentType}}`,
  customize_invoice_sequencing: `Personalizar la secuencia de facturas`,
  configure_document_series: `Configurar serie de documentos`,
  regular_invoice: `Factura Regular`,
  verifactu: `Verifactu`,
  sdi: `SDI`,
  sii: `SII`,
  logo_url_missing: `Falta la URL del logotipo`,
  edit_vendor_information: `Editar información del mi`,
  fill_vendor_details: `Complete los detalles del mi para agregarlo a su lista`,
  add_logo_url: `Agregar URL del logotipo`,
  vendor_email_address: `Correo electrónico del mi`,
  company_street: `Calle de la empresa`,
  company_street_number: `Número de calle`,
  company_locality: `Localidad`,
  company_zip_code: `Código postal`,
  company_region: `Región`,
  add_po_number: `Agregar número de OC`,
  po_number: `Número de OC`,
  add_delivery_note: `Agregar nota de entrega`,
  add_pec_code: `Agregar código PEC`,
  pec_code: `Código PEC`,
  pec_code_is_missing: `Falta el código PEC`,
  add_destination_code: `Agregar código de destino`,
  destination_code: `Código de destino`,
  destination_code_is_missing: `Falta el código de destino`,
  invoice_information: `Información de la factura`,
  purchase_order_information: `Información de la orden de compra`,
  delivery_note_information: `Información de la nota de entrega`,
  connected_documents: `Documentos conectados`,
  search_or_add_a_new_customer: `Buscar o agregar un nuevo cliente`,
  'no_items_added-click_on_add__line_item_to_add_items': `No se han agregado artículos — haga clic en "Agregar artículo" para agregarlos`,
  line_items: `Artículos`,
  add_line_item: `Agregar artículo`,
  search_by_reference_code_or_description_or_add_new_item: `Buscar por código de referencia o descripción, o agregar nuevo artículo`,
  search_by_reference_code_description_keywords: `Buscar por código, descripción, palabras clave`,
  add_discount: `Agregar descuento`,
  also_add_this_item_to_catalog: `Agregar también este artículo al catálogo`,
  total_breakdown: `Desglose total`,
  wht_tax: `Retención`,
  total_amount: `Importe total`,
  additional_options: `Opciones adicionales`,
  additional_tax: `Impuesto adicional`,
  support_documents: `Documento de soporte`,
  supporting_documents: `Documento de respaldo`,
  discount_type: `Tipo de descuento`,
  percentage: `Porcentaje`,
  base_amount: `Importe base`,
  make_recurring_invoice: `Hacer factura recurrente`,
  preview_pdf: `Vista previa PDF`,
  cancel: `Cancelar`,
  monthly: `Mensual`,
  yearly: `Anual`,
  taxes_permission_required: `Se requiere permiso de impuestos`,
  add_new_tax: `Agregar nuevo impuesto`,
  edit_tax: `Editar impuesto`,
  rate: `Tasa`,
  is_withholding_tax: `Es impuesto de retención`,
  VAT_label: `VAT - Impuesto sobre el Valor Añadido`,
  IGIC_label: `IGIC - Impuesto General Indirecto Canario`,
  IRPF_label: `IRPF - Impuesto sobre la Renta de las Personas Físicas`,
  WHT_label: `WHT - Impuesto de retención`,
  tax_type_required: `El tipo de impuesto es obligatorio`,
  rate_required: `La tasa es obligatoria`,
  rate_min: `La tasa debe ser mayor o igual a 0`,
  tax_created_success: `Impuesto creado exitosamente`,
  tax_updated_success: `Impuesto actualizado exitosamente`,
  error_fetching_tax_data: `Error al obtener los datos del impuesto`,
  update: `Actualizar`,

  // modal de edición de cliente
  edit_customer_information: `Editar información del cliente`,
  fill_customer_details: `Complete los datos del cliente para agregarlo a su lista`,
  customer_address: `Dirección del`,
  customer_company_name: `Nombre del`,
  customer_company_ID: `ID del`,
  customer_email_address: `Correo electrónico del`,
  customerCurrency_is_required: `La moneda del es obligatoria`,
  currency: `Moneda`,
  delete_customer_title: `¿Está seguro de que desea eliminar al?`,
  delete_customer_warning: `Eliminar al no lo borrará, pero sí lo eliminará de su factura`,
  delete_vendor_title: `¿Está seguro de que desea eliminar al proveedor?`,
  delete_vendor_warning: `Eliminar al proveedor no lo borrará, pero sí lo eliminará de su factura`,
  item_delete_title: `¿Está seguro de que desea eliminar este artículo(s)?`,
  item_delete_warning: `Eliminar el artículo lo eliminará de su factura`,
  // opciones adicionales
  item_level_discount_already_added: `Ya hay un descuento aplicado a nivel de artículo. Deshabilítelo antes de agregar un descuento a nivel de documento.`,

  // modal de serie de documentos (nuevo UI)
  customize_invoice_sequencing_number: `Personalizar el número de secuencia de facturas`,
  sequence_number_sub_text: `Cree una nueva regla de numeración, o vea las reglas existentes y anteriores`,
  add_new_sequencing_rule: `Agregar nueva regla de numeración`,
  add_new_sequence_rule_description: `Agregar una nueva regla reemplaza la regla activa actual`,
  add_new_rule: `Agregar nueva regla`,
  starting_number: `Número inicial`,
  delete_series: `¿Eliminar serie?`,
  delete_series_warning: `Eliminar esta serie la eliminará de su documento.`,
  deactive_series: `Serie desactivada`,
  deactivate: `Desactivar`,
  deactivate_sequence_title: `¿Desactivar esta secuencia?`,
  deactivate_sequence_note: `Nota: Necesitará una secuencia activa para crear nuevas facturas.`,
  add_new: `Agregar nuevo`,
  add_series_warning: `Al añadir esta serie se reemplazará la activa. ¿Continuar?`,
  select_or_type_vendor_company_id: `Seleccionar ID de empresa proveedora`,
  invoicecompliance_module_not_enabled: `El módulo de cumplimiento de facturas no está habilitado.`,
  please_enter_company_name: 'Por favor, ingrese un nombre de empresa',
  please_select_company_id: 'Por favor, seleccione un ID de empresa',
  please_select_country: 'Por favor, seleccione un país',
  please_select_currency: 'Por favor, seleccione una moneda',
  tax_percentage_is_required: 'El porcentaje de impuesto es obligatorio',
  click_to_upload: `Haga clic para subir`,
  no_invoice_number: 'Sin número de factura',
  file_size_exceeds: 'El tamaño del archivo excede los 5MB',
  'supported_document.pdf': `documento_soporte.pdf`,
  discount_amount: `Monto del descuento`,
  reference_code: 'Código de referencia',
  tax_amount: 'Monto del impuesto',
  edit_my_information: `Editar información`,
  fill_my_details: `Complete los detalles para agregarlos a su lista`,
  edit_supplier_information: `Editar información del proveedor`,
  fill_supplier_details: `Complete los detalles del proveedor para agregarlos a su lista`,

  'Basic Information': `Información Básica`,
  'Peppol Inbox Configuration': `Configuración de Bandeja Peppol`,

  peppol_inbox_configuration: {
    add_configuration: `Añadir Configuración`,
    edit_configuration: `Editar Configuración`,
    create: `Crear`,
    company_id: `ID de empresa`,
    country: `País`,
    peppol_participant_id: `ID de participante Peppol`,
    scheme_id: `ID de esquema`,
    select_company_id: `Seleccionar ID de empresa`,
    company_id_required: `El ID de empresa es obligatorio`,
    country_required: `El país es obligatorio`,
    peppol_participant_id_required: `El ID de participante Peppol es obligatorio`,
    scheme_id_required: `El ID de esquema es obligatorio`,
    created_successfully: `Configuración creada correctamente`,
    updated_successfully: `Configuración actualizada correctamente`,
    deleted_successfully: `Configuración eliminada correctamente`,
    delete_configuration_title: `Eliminar Configuración`,
    delete_configuration_warning: `¿Estás seguro de que deseas eliminar esta configuración Peppol?`,
    peppol_inbox_details_for_company_id: `Detalles de bandeja Peppol para el ID de empresa`,
  },
  // Compliance Legal Representative
  legal_representative: `Representante Legal`,
  legal_representative_created: `Representante legal creado con éxito`,
  legal_representative_updated: `Representante legal actualizado con éxito`,
  role: `Rol`,
  address_information: `Información de dirección`,
  additional_documents: `Documentos adicionales`,
  View: `Ver`,
  permission_not_granted: `No tienes permiso para realizar esta acción`,

  // Legal representative validation
  legal_rep_email_required: `El correo electrónico es obligatorio`,
  legal_rep_email_invalid: `El correo electrónico debe ser válido`,
  legal_rep_role_required: `El rol es obligatorio`,
  legal_rep_country_required: `El país es obligatorio`,

  // Unsaved changes dialog
  unsaved_changes: `Cambios sin guardar`,
  doc_configuration_unsaved_changes_warning: `Tiene cambios sin guardar. ¿Desea guardar antes de cambiar de pestaña?`,
  unsaved_changes_confirm: `Guardar y continuar`,
  unsaved_changes_cancel: `Quedarse`,
};

export default es;
